export default {
  nav: {
    spreadsheet: 'Tabelle',
    categories: 'Kategorien',
    products: 'Produkte',
    guides: 'Guides',
    reviews: 'Bewertungen',
    shipping: 'Versand',
    safety: 'Sicherheit',
    comparisons: 'Vergleiche',
    faq: 'FAQ',
    mainSite: 'Hauptseite',
  },
  languages: {
    en: 'English',
    fr: 'Français',
    da: 'Dansk',
    de: 'Deutsch',
  },
  hero: {
    h1: 'AllChinaBuy Spreadsheet — Produkte, Verkäufer & Kaufrressourcen Finden',
    subtitle: 'Erkunden Sie das AllChinaBuy-Spreadsheet, Produktlisten, Verkäuferressourcen, QC-Guides, Versandinformationen und praktische Kauftipps — alles in einem benutzerfreundlichen Ressourcen-Hub organisiert.',
    ctaPrimary: 'AllChinaBuy Spreadsheet Erkunden',
    ctaSecondary: 'Hauptseite Besuchen',
    searchPlaceholder: 'AllChinaBuy-Spreadsheet, Produkte, Verkäufer oder Guides suchen…',
    trust: 'Unabhängige Ressource • Regelmäßig Aktualisiert • Anfängerfreundlich',
  },
  categories: {
    title: 'Beliebte Kategorien',
    subtitle: 'Stöbern Sie Produkte nach Kategorie und entdecken Sie die besten Artikel über AllChinaBuy',
    viewAll: 'Alle Kategorien Anzeigen',
  },
  dropdown: {
    label: 'Kategorie Auswählen',
    placeholder: 'Produktkategorie wählen...',
    goButton: 'Zur Kategorie',
  },
  ctas: {
    exploreTitle: 'AllChinaBuy Spreadsheet',
    exploreDesc: 'Greifen Sie auf das vollständige Produkt- und Verkäufer-Spreadsheet mit kuratierten Links und aktualisierten Informationen zu.',
    exploreButton: 'AllChinaBuy Spreadsheet',
    buyTitle: 'Jetzt Kaufen',
    buyDesc: 'Überspringen Sie die Recherche und gehen Sie direkt zur Hauptseite, um sofort einzukaufen.',
    buyButton: 'Jetzt Kaufen',
  },
  spreadsheet: {
    title: 'Spreadsheet Explorer',
    subtitle: 'Navigieren Sie mühelos durch das AllChinaBuy-Spreadsheet. Finden Sie Produkte, Verkäufer und Ressourcen für schnellen Zugriff.',
    feature1: 'Kuratierte Produktlinks',
    feature2: 'Verifiziertes Verkäuferverzeichnis',
    feature3: 'Regelmäßig Aktualisiert',
    feature4: 'Anfängerfreundlich',
  },
  featured: {
    title: 'Empfohlene Produkte',
    subtitle: 'Entdecken Sie angesagte Artikel aus der AllChinaBuy-Spreadsheet-Community',
  },
  guides: {
    title: 'Neueste Guides',
    subtitle: 'Schritt-für-Schritt-Anleitungen zum sicheren Recherchieren, Kaufen und Versenden von Produkten',
    readMore: 'Guide Lesen',
    guide1Title: 'Kompletter Guide zum AllChinaBuy Spreadsheet',
    guide1Desc: 'Lernen Sie alles über die effektive Nutzung des AllChinaBuy-Spreadsheets für die Produktrecherche.',
    guide2Title: 'Zuverlässige Verkäufer Finden',
    guide2Desc: 'Wichtige Tipps zur Bewertung der Verkäuferreputation und Vermeidung häufiger Fallstricke.',
    guide3Title: 'Versand- & Lager Guide',
    guide3Desc: 'Vergleichen Sie Versandmethoden, berechnen Sie Kosten und wählen Sie die beste Lieferoption.',
    guide4Title: 'AllChinaBuy Bewertung 2026',
    guide4Desc: 'Ehrliche und aktuelle Bewertung der AllChinaBuy-Plattform, Funktionen und Benutzererfahrung.',
  },
  trust: {
    title: 'Warum Dieser Ressource Vertrauen?',
    independent: 'Unabhängige Plattform',
    independentDesc: 'Wir sind nicht mit AllChinaBuy verbunden. Unser Ziel ist es, ehrliche, hilfreiche Informationen bereitzustellen.',
    updated: 'Regelmäßig Aktualisiert',
    updatedDesc: 'Inhalte werden überprüft und aktualisiert, um die neuesten Plattformänderungen und Versandkosten widerzuspiegeln.',
    beginner: 'Anfängerfreundlich',
    beginnerDesc: 'Klare Erklärungen und Schritt-für-Schritt-Anleitungen erleichtern den Einstieg für neue Benutzer.',
  },
  searchCards: {
    title: 'Beliebte Suchen',
    spreadsheet: 'AllChinaBuy Spreadsheet',
    review: 'AllChinaBuy Bewertung',
    shipping: 'AllChinaBuy Versandkosten',
    coupon: 'AllChinaBuy Gutschein',
    discount: 'AllChinaBuy Rabattcode',
    warehouse: 'AllChinaBuy Lager',
    legit: 'AllChinaBuy Legitim',
    qc: 'AllChinaBuy QC',
  },
  finalCta: {
    title: 'Bereit, Mehr Produkte zu Erkunden?',
    subtitle: 'Nutzen Sie unsere Guides für die Recherche, und gehen Sie dann zur Hauptseite, um mehr Produkte zu entdecken.',
    button: 'Zur Hauptseite Weiter',
  },
  footer: {
    about: 'Über Uns',
    contact: 'Kontakt',
    editorial: 'Redaktionelle Richtlinie',
    privacy: 'Datenschutz',
    terms: 'Bedingungen',
    disclaimer: 'Haftungsausschluss',
    affiliate: 'Partnerhinweis',
    description: 'Ein unabhängiger Ressourcen-Hub für AllChinaBuy-Spreadsheet-Benutzer. Wir helfen Käufern bei der Recherche von Produkten, Verkäufern und Versandoptionen vor dem Kauf.',
    copyright: 'Alle Rechte vorbehalten.',
    notAffiliated: 'Diese Website ist eine unabhängige Informationsressource und nicht die offizielle AllChinaBuy-Website.',
  },
  breadcrumb: {
    home: 'Startseite',
  },
  article: {
    toc: 'Inhaltsverzeichnis',
    updated: 'Aktualisiert',
    author: 'Autor',
    readTime: 'Min. Lesezeit',
    related: 'Verwandte Artikel',
    backToHome: 'Zurück zur Startseite',
  },
  faq: {
    title: 'Häufig Gestellte Fragen',
    q1: 'Was ist das AllChinaBuy-Spreadsheet?',
    a1: 'Das AllChinaBuy-Spreadsheet ist eine kuratierte Sammlung von Produktlinks, Verkäuferinformationen und Kaufressourcen, die Käufern helfen, Artikel effizient über die AllChinaBuy-Plattform zu finden.',
    q2: 'Ist AllChinaBuy legitim?',
    a2: 'AllChinaBuy ist eine legitime Einkaufsagenten-Plattform. Wie bei jedem Online-Kauf sollten Käufer jedoch Verkäufer recherchieren, QC-Fotos überprüfen und Versandkosten verstehen, bevor sie bestellen.',
    q3: 'Wie verwende ich das AllChinaBuy-Spreadsheet?',
    a3: 'Durchsuchen Sie das Spreadsheet nach Kategorie, klicken Sie auf Produktlinks für Details, vergleichen Sie Verkäufer und nutzen Sie die bereitgestellten Links zur AllChinaBuy-Plattform für den Kauf.',
    q4: 'Welche Versandmethoden bietet AllChinaBuy?',
    a4: 'AllChinaBuy bietet mehrere Versandoptionen einschließlich internationalem Express, Standardversand und Lagerkonsolidierung. Kosten variieren je nach Ziel und Paketgewicht.',
  },
  comparison: {
    title: 'Wie Sich AllChinaBuy Vergleicht',
    feature: 'Funktion',
    productDiscovery: 'Produktentdeckung',
    spreadsheetResources: 'Spreadsheet-Ressourcen',
    qc: 'QC Fotos',
    warehouse: 'Lagerspeicherung',
    shipping: 'Versandoptionen',
    payment: 'Zahlungsmethoden',
    support: 'Kundensupport',
  },
  safety: {
    title: 'Sicherheitszentrum',
    subtitle: 'Wichtige Informationen, um Ihnen beim sicheren Einkaufen und Vermeiden häufiger Risiken zu helfen',
    payment: 'Zahlungssicherheit',
    paymentDesc: 'Verwenden Sie sichere Zahlungsmethoden und teilen Sie niemals Login-Daten direkt mit Verkäufern.',
    verification: 'Verkäuferverifizierung',
    verificationDesc: 'Überprüfen Sie Verkäuferbewertungen, Rezensionshistorie und Community-Feedback vor Bestellung.',
    qc: 'QC Sicherheit',
    qcDesc: 'Fordern Sie immer QC-Fotos an und überprüfen Sie diese vor Genehmigung von Versendungen aus dem Lager.',
    scams: 'Häufige Betrugsversuche',
    scamsDesc: 'Lernen Sie, verdächtige Links, gefälschte Verkäufer und häufige Phishing-Versuche zu erkennen.',
  },
};